import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export namespace NICmsMerchandiser {
    /**
     * Merchandiser configs url
     */
    export const configId = 'merchandiser';
    /**
     * Merchandiser data
     * id - product id
     * value - position in the list, false means hide
     */
    export interface IData {
        order: number[];
        hidden: number[];
    }
}

ICmsContentService.registerConfig({
    id: NICmsMerchandiser.configId,
    name: 'Visual merchandiser data',
    selfManaged: true,
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'order',
            title: 'Products ordered',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Product',
            fields: [],
            default: []
        },

        <NICmsContentField.IRepeaterField>{
            key: 'hidden',
            title: 'Hidden products',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Hidden product',
            fields: [],
            default: []
        }
    ]
});
